module.exports = __webpack_public_path__ + "click-me-0b979c4e553fce7c3b73e710d1eb94c5.webp";